import { SvgIconProps, SvgIcon

 } from '@mui/material';
import styles from './ccf-agent-search-email-outbound-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfAgentSearchEmailOutboundIconProps extends SvgIconProps {}

export function CcfAgentSearchEmailOutboundIcon(
  props: CcfAgentSearchEmailOutboundIconProps
) {
  return (
    <SvgIcon
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 26 13"
        id="EMAIL_OB"
      >
        <path
          d="M25.0965 0.453429C24.8565 0.282009 24.6165 0.196289 24.2965 0.196289H11.4965C11.1765 0.196289 10.9365 0.282009 10.6965 0.453429L17.8965 5.25347L25.0965 0.453429Z"
          fill="#E6258D"
        ></path>
        <path
          d="M25.8965 1.91052L18.2965 6.96761C18.2165 6.96761 18.0565 7.05341 17.8965 7.05341C17.7365 7.05341 17.5765 6.96761 17.4965 6.88191L9.89648 1.91052V10.4819C9.89648 11.4248 10.6165 12.1962 11.4965 12.1962H24.2965C25.1765 12.1962 25.8965 11.4248 25.8965 10.4819V1.91052Z"
          fill="#E6258D"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.0867 11.448C3.0867 12.0003 3.53441 12.448 4.0867 12.448C4.63898 12.448 5.0867 12.0003 5.0867 11.448V5.24779H7.0162C7.25522 5.24779 7.39825 4.98189 7.26653 4.78244L4.32673 0.33096C4.20747 0.15037 3.94204 0.15164 3.8245 0.33335L0.945082 4.78483C0.815964 4.98444 0.959246 5.24779 1.19698 5.24779H3.0867V11.448Z"
          fill="#E6258D"
        ></path>
    </SvgIcon>
  );
}

export default CcfAgentSearchEmailOutboundIcon;
